import { useState, useEffect, useMemo } from "react";

type CountdownResult = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isExpired: boolean;
};

export function useCountdown(targetDate: Date): CountdownResult {
  const targetMs = useMemo(() => targetDate.getTime(), [targetDate]);

  const calcRemaining = () => Math.max(0, targetMs - Date.now());

  const [remainingMs, setRemainingMs] = useState(calcRemaining);

  useEffect(() => {
    if (remainingMs <= 0) return;

    const interval = setInterval(() => {
      const next = calcRemaining();
      setRemainingMs(next);
      if (next <= 0) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [targetMs]);

  const isExpired = remainingMs <= 0;
  const totalSeconds = Math.floor(remainingMs / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { days, hours, minutes, seconds, isExpired };
}
